import { atom } from 'jotai';

export const languageAlternatesAtom = atom<
  | {
      currentPathname: string;
      alternateLinks?: Record<string, string>;
    }
  | undefined
>(undefined);
